import Axios from 'axios';
import { toastr } from 'react-redux-toastr';
import * as sourceTypeActions from './sourceReducer';
import queryString from '../../../helpers/queryString';
import handleErrorResponse from '../../../helpers/handleErrorResponse';

export const defaultIncludes = [];

const createSourceType = (values) => {
  return () => {
    return Axios.post('source-types', values)
      .then(() => {
        toastr.success('Success', 'source type has been created');
        return true;
      })
      .catch((error) => {
        handleErrorResponse(error, 'Failed');
      });
  };
};

const updateSourceType = (values, includes = defaultIncludes) => {
  return () => {
    let endpoint = 'source-types/' + values.data.id;
    endpoint += queryString(includes);

    return Axios.patch(endpoint, values)
      .then(() => {
        toastr.success('Success', 'source has been updated');
        return true;
      })
      .catch((error) => {
        handleErrorResponse(error, 'Failed');
      });
  };
};

const setBrokerSourceType = () => {
  let endpoint = 'source-types?filter[name]=Broker&filter[source_type]=Broker';

  return (dispatch) => {
    return Axios.get(endpoint)
      .then((response) => {
        dispatch({
          type: sourceTypeActions.SET_BROKER_SOURCE_TYPE,
          data: response.data.data[0],
        });
        return response.data.data[0];
      })
      .catch((error) => {
        console.error(error);
      });
  };
};

const setSourceTypes = (filters = []) => {
  let endpoint = 'source-types' + (filters ? '?' + filters : '');

  return (dispatch) => {
    return Axios.get(endpoint)
      .then((response) => {
        dispatch({
          type: sourceTypeActions.SET_SOURCE_TYPES,
          data: response.data,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };
};

const getSourceType = (id, includes = defaultIncludes) => {
  return (dispatch) => {
    let endpoint = 'source-types/' + id;
    endpoint += queryString(includes);

    return Axios.get(endpoint)
      .then((response) => {
        dispatch({
          type: sourceTypeActions.SET_SOURCE_TYPE,
          data: response.data,
        });
        return response.data;
      })
      .catch((error) => {
        console.error(error);
      });
  };
};

export const actions = {
  getSourceType,
  setSourceTypes,
  setBrokerSourceType,
  updateSourceType,
  createSourceType,
};
